import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { ConnectedPosition, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { TooltipComponent } from '../components';

const POSITIONS: { [key: string]: ConnectedPosition[] } = {
  top: [{ originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom' }],
  bottom: [{ originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' }],
  left: [{ originX: 'start', originY: 'center', overlayX: 'end', overlayY: 'center' }],
  right: [{ originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'center' }],
};

@Directive({
  selector: '[ktTooltip]',
})
export class TooltipDirective implements OnDestroy {
  private overlayRef: OverlayRef | null = null;
  @Input() ktTooltip = '';
  @Input() ktTooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() ktTooltipTextAlign: 'left' | 'right' | 'center' = 'center';
  @Input() ktTooltipMaxWidth = '150px';

  constructor(private overlay: Overlay, private elementRef: ElementRef) {}

  private getPositions(): ConnectedPosition[] {
    return POSITIONS[this.ktTooltipPosition];
  }

  @HostListener('mouseenter') onMouseEnter() {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.elementRef)
      .withPositions(this.getPositions());

    this.overlayRef = this.overlay.create({ positionStrategy });

    const tooltipPortal = new ComponentPortal(TooltipComponent);
    const tooltipRef = this.overlayRef.attach(tooltipPortal);

    tooltipRef.instance.text = this.ktTooltip;
    tooltipRef.instance.position = this.ktTooltipPosition;
    tooltipRef.instance.textAlign = this.ktTooltipTextAlign;
    tooltipRef.instance.maxWidth = this.ktTooltipMaxWidth;
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.overlayRef?.detach();
  }

  ngOnDestroy() {
    this.overlayRef?.dispose();
  }
}
